export type SafeJSONParse = <T = any>(
  json: string | null,
  fallback?: T | null
) => T | null

export const safeJSONParse: SafeJSONParse = (json, fallback = null) => {
  if (!json) return fallback
  try {
    return JSON.parse(json)
  } catch {
    return fallback
  }
}
